module.exports = __webpack_public_path__ + "img/ssmartlocator.2cad87c8.svg";